import { render, staticRenderFns } from "./InfoValidityIcon.vue?vue&type=template&id=7dbf0978"
import script from "./InfoValidityIcon.vue?vue&type=script&lang=js"
export * from "./InfoValidityIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports